import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinKyuyoDownloadCsvPostReq,
  TZyomuinKyuyoInfoGetRes,
  TZyomuinKyuyoListGetReq,
  // TZyomuinKyuyoRegisterPutReq,
  TZyomuinKyuyoZissekiPutReq,
} from "./TZyomuinKyuyo"

/**
 * 乗務員給与に対するAPIリクエスト用サービス
 *
 * @export
 * @class ZyomuinKyuyoService
 * @extends {ConnectApi}
 */
export default class ZyomuinKyuyoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinKyuyoListGetReq} params
   * @memberof ZyomuinKyuyoService
   */
  getList = async (params: TZyomuinKyuyoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinKyuyoInfoGetRes[]>> =
        await this.getInner(`/driverpayroll/zyomuinkyuyo/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TZyomuinKyuyoListGetReq} params
   * @memberof ZyomuinKyuyoService
   */
  get = async (id: string | number) => {
    // try {
    //   const res: AxiosResponse<TApiResponse<TZyomuinKyuyoInfoGetRes>> =
    //     await this.getInner(`/ZyomuinKyuyo/${id}`)
    //   return res.data
    // return {
    // data: EditDummy,
    // }
    // } catch (err) {
    //   throw err
    // }

    return {
      // TODO:あとで消す
    }
  }

  /**
   * 給与実績更新
   *
   * @param {TZyomuinKyuyoRegisterPutReq} data
   * @memberof ZyomuinKyuyoService
   */
  put = async (data: TZyomuinKyuyoZissekiPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinkyuyo/register`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * CSVダウンロード処理
   *
   * @param {TZyomuinKyuyoDownloadCsvPostReq} params
   * @memberof ZyomuinKyuyoService
   */
  downloadCsv = async (params: TZyomuinKyuyoDownloadCsvPostReq) => {
    try {
      const res: AxiosResponse<Blob> = await this.postInner(
        `/driverpayroll/zyomuinkyuyo/actions/downloadcsv`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
